import { computed } from '@vue/composition-api';
import { RouteName } from '@/router/route-name';

export default (
  param: { nextPage: RouteName; prevPage: RouteName },
  contextModify?: () => void,
  skipCallApiTypePost?: boolean | undefined,
) => ({
  /**
   * atoneの登録画面のリンク先を解決します。
   * @returns
   */
  useLinks: () =>
    computed(() => ({
      nextPage: {
        name: param.nextPage,
      },
      prevPage: {
        name: param.prevPage,
      },
    })),
  contextModify,
  skipCallApiTypePost,
});
